import { fb, validators } from "form";
import { categories, styles } from "site/data";

export function getProductEditModel(data) {
  // let projectList = data.projectList.map((p) => { return { name: getProjectName(p), value: p.projectCode }});
  // projectList = [{ name: 'Select...', value: '' }, ...projectList];

  let categoryList = categories.map((x) => {
    return { name: x.category, value: x.category };
  });
  categoryList = [{ name: "Select...", value: "" }, ...categoryList];

  const statusList = [
    { name: "Live", value: "0" },
    { name: "Archived", value: "97" },
    { name: "Discontinued", value: "98" },
    { name: "N/A", value: "99" },
  ];

  const styleList = styles.map((x) => {
    return { name: x, value: x };
  });
  const filterList = data.filterList.map((x) => {
    return { name: x.filterName, value: x.filterCode };
  });

  console.log("getProductEditModel", data);

  const model = fb.group({
    productStatusAU: [
      data.productStatusAU,
      [validators.Required()],
      { type: "select", options: statusList },
    ],
    productStatusNZ: [
      data.productStatusNZ,
      [validators.Required()],
      { type: "select", options: statusList },
    ],

    productCode: [
      data.productCode || "",
      [validators.Required()],
      { type: "text" },
    ],
    productName: [
      data.productName || "",
      [validators.Required()],
      { type: "text" },
    ],
    productUrl: [
      data.productUrl || "",
      [validators.Required()],
      { type: "text" },
    ],
    bookletLink: [data.bookletLink || "", [], { type: "text" }],
    metaImage: [data.metaImage || "", [], null],
    recipeBookletLink: [data.recipeBookletLink || "", [], { type: "text" }],
    category: [
      data.category || "",
      [validators.Required()],
      { type: "select", options: categoryList },
    ],
    category2: [
      data.category2 || "",
      [],
      { type: "select", options: categoryList },
    ],
    barcode: [data.barcode || "", [], { type: "text" }],
    barcodeUPC: [
      data.barcodeUPC || "",
      [],
      { label: "Barcode(UPC)", type: "text" },
    ],
    styles: [
      data.styles || [],
      [],
      { type: "checkboxList", options: styleList, style: { inline: true } },
    ],
    filters: [
      data.filters || [],
      [],
      { type: "checkboxList", options: filterList, style: { inline: true } },
    ],
    priceAU: [data.priceAU || "", [], { type: "number", label: "Price (AU$)" }],
    priceNZ: [data.priceNZ || "", [], { type: "number", label: "Price (NZ$)" }],
    warranty: [
      data.warranty || "",
      [],
      { type: "text", label: "Waranty Year" },
    ],
    relatedProducts: [
      data.relatedProducts.join("\n") || "",
      [],
      {
        type: "textarea",
        label: "Related Products - product code in each line",
        style: { rows: 10 },
      },
    ],
    productImages: [data.productImages || [], [], null],
    productStores: [data.productStores || [], [], null],
    intro: [data.intro || "", [], { type: "textarea", style: { rows: 7 } }],
    metaDesc: [
      data.metaDesc || "",
      [],
      {
        type: "textarea",
        label: "Meta Description (if empty, Intro will be used)",
        style: { rows: 7 },
      },
    ],
    // forAU: [data.forAU, [], { label: "AU", type: "checkbox" }],
    // forNZ: [data.forNZ, [], { label: "NZ", type: "checkbox" }],
    trendingNow: [
      data.trendingNow || "",
      [],
      { label: "Trending Now", type: "checkbox" },
    ],
    useSparePartInstruction: [
      data.useSparePartInstruction || "",
      [],
      { label: "Use common Spare Part Instruction", type: "checkbox" },
    ],

    sortingOrder: [
      data.sortingOrder || "",
      [],
      {
        type: "text",
        label: "Sorting Order (any text)",
        helpText:
          "Done by character sorting, not numeric sorting, i.e., 12 comes before 2. Use paddings if you are going to use numbers like 001, 002, 012. You may use any group name here.",
      },
    ],
    mpn: [
      data.mpn || "",
      [],
      {
        type: "text",
        label: "MPN (If empty, Product Code(non SKU_*) will be used)",
        helpText:
          '<a href="https://support.google.com/manufacturers/answer/7421352?hl=en&ref_topic=7420644" target="_blank">More info(Google)</a>',
      },
    ],
    mfTitle: [
      data.mfTitle || "",
      [],
      {
        type: "text",
        label:
          "Title (If empty, Sitename + Product Name + Product Code(non SKU_*) will be used)",
        helpText:
          '<a href="https://support.google.com/manufacturers/answer/7496598?hl=en&ref_topic=7420644" target="_blank">More info(Google)</a>',
      },
    ],
    mfDesc: [
      data.mfDesc || "",
      [],
      {
        type: "textarea",
        label: "Description (if empty, Intro will be used)",
        style: { rows: 7 },
        helpText:
          '<a href="https://support.google.com/manufacturers/answer/7496383?hl=en&ref_topic=7420644" target="_blank">More info(Google)</a>',
      },
    ],
    mfProductType1: [
      data.mfProductType1 || "",
      [],
      {
        type: "text",
        label: "Product Type (categorisation, i.e., Women > Hair Dryer > ...)",
      },
    ],
    mfProductType2: [
      data.mfProductType2 || "",
      [],
      { type: "text", label: null },
    ],
    mfProductType3: [
      data.mfProductType3 || "",
      [],
      { type: "text", label: null },
    ],
    mfProductType4: [
      data.mfProductType4 || "",
      [],
      { type: "text", label: null },
    ],
    mfProductType5: [
      data.mfProductType5 || "",
      [],
      { type: "text", label: null },
    ],
    // details: [data.details || '', [], { type: 'html', style: { } }],
    // styleTips: [data.styleTips || '', [], { type: 'html', style: { } }],
    // seeMore: [data.seeMore || '', [], { type: 'html', style: { } }],
    // specifications: [data.specifications || '', [], { type: 'html', style: { } }],
    howToSection: fb.array([]),
    discoverMoreSection: fb.array([]),
    faqSection: fb.array([]),
    whereToBuySection: fb.array([]),
    detailSection: fb.array([]),
    specSection: fb.array([]),
    seeMoreSection: fb.array([]),
    //youtubeSection : fb.array([]),
  });

  // const itemArray = model.find('detailSection').controls;
  // data.detailSection.forEach(item => {
  //   itemArray.push(fb.group({
  //     itemValue: [item.itemValue || '', [], { type: 'html', label: null, style: { } }],
  //     itemStatus: [item.itemStatus, [], { type: 'select', style: { } }],
  //     itemId: [item.itemId],
  //     itemTypeCode: [item.itemTypeCode]
  //   }))
  // })

  buildArray(data.howToSection, model.find("howToSection").controls);
  buildArray(
    data.discoverMoreSection,
    model.find("discoverMoreSection").controls
  );
  buildArray(data.faqSection, model.find("faqSection").controls);
  buildArray(data.whereToBuySection, model.find("whereToBuySection").controls);
  buildArray(data.detailSection, model.find("detailSection").controls);
  buildArray(data.specSection, model.find("specSection").controls);
  buildArray(data.seeMoreSection, model.find("seeMoreSection").controls);
  //buildArray(data.youtubeSection, model.find('youtubeSection').controls);

  return model;
}

function buildArray(items, itemArray) {
  items.forEach((item) => {
    itemArray.push(createGroup(item));
  });
}

const specSectionList = [
  { name: "Left", value: "L" },
  { name: "Right", value: "R" },
];
//const linkTypeList = [{ name: 'Auto', value: 'auto' }, { name: 'Blog', value: 'blog' }, { name: 'Instagram', value: 'instagram' }, { name: 'Web', value: 'web' }];
const linkTypeList = [
  { name: "Auto", value: "auto" },
  { name: "Instagram", value: "instagram" },
  { name: "Tiktok", value: "tiktok" },
];

export function createGroup(item) {
  const group = {
    itemStatus: [item.itemStatus, [], { type: "select", style: {} }],
    itemId: [item.itemId],
    itemTypeCode: [item.itemTypeCode],
  };

  const g = fb.group({ ...group, ...createItem(item) });
  g.customValueFn = getItemValue;
  return g;
}

export function createItem(item) {
  if (item.itemTypeCode === "video") {
    if (!item.itemValue) return null;
    const video = JSON.parse(item.itemValue);
    //console.log(video);
    return {
      videoUrl: [
        video.video || "",
        [],
        { type: "text", label: "Youtube Id or Url" },
      ],
      title: [video.title || "", [], { type: "text", label: "Title" }],
      desc: [
        video.desc || "",
        [],
        { type: "html", label: "Short Description", style: {} },
      ],
    };
  }

  if (item.itemTypeCode === "qa") {
    if (!item.itemValue) return null;
    const qa = JSON.parse(item.itemValue);
    //console.log(video);
    return {
      question: [
        qa.question || "",
        [],
        { type: "textarea", label: "Question" },
      ],
      answer: [
        qa.answer || "",
        [],
        { type: "html", label: "Answer", style: {} },
      ],
    };
  }

  if (item.itemTypeCode === "spec") {
    if (!item.itemValue) return null;
    const spec = JSON.parse(item.itemValue);
    //console.log(video);
    return {
      category: [
        spec.category || "",
        [],
        { type: "select", label: "Section", options: specSectionList },
      ],
      label: [spec.label || "", [], { type: "text", label: "Label" }],
      text: [
        spec.text || "",
        [],
        { type: "text", label: "Specification", style: {} },
      ],
    };
  }

  if (item.itemTypeCode === "html") {
    return {
      html: [
        item.itemValue || "",
        [],
        { type: "html", label: null, style: {} },
      ],
    };
  }

  if (item.itemTypeCode === "link") {
    if (!item.itemValue) return null;
    const link = JSON.parse(item.itemValue);
    return {
      linkType: [
        link.linkType || "auto",
        [],
        { type: "select", label: "Type", options: linkTypeList },
      ],
      title: [link.title || "", [], { type: "text", label: "Title" }],
      url: [link.url || "", [], { type: "text", label: "URL", style: {} }],
    };
  }

  if (item.itemTypeCode === "weblink") {
    if (!item.itemValue) return null;
    const link = JSON.parse(item.itemValue);
    return {
      //linkType: [link.linkType || 'auto', [], { type: 'select', label: 'Type', options: linkTypeList }],
      title: [link.title || "", [], { type: "text", label: "Title" }],
      url: [link.url || "", [], { type: "text", label: "URL", style: {} }],
    };
  }
}

function getItemValue(item, fns) {
  const val = (name) => {
    const control = item.find(name);
    return control ? control.value : null;
  };
  const value = {
    itemStatus: val("itemStatus"),
    itemId: val("itemId"),
    itemTypeCode: val("itemTypeCode"),
  };

  if (value.itemTypeCode === "video") {
    value.itemValue = JSON.stringify({
      video: val("videoUrl"),
      title: val("title"),
      desc: val("desc"),
    });
  } else if (value.itemTypeCode === "qa") {
    value.itemValue = JSON.stringify({
      question: val("question"),
      answer: val("answer"),
    });
  } else if (value.itemTypeCode === "spec") {
    value.itemValue = JSON.stringify({
      category: val("category"),
      label: val("label"),
      text: val("text"),
    });
  } else if (value.itemTypeCode === "html") {
    value.itemValue = val("html");
  } else if (value.itemTypeCode === "link") {
    value.itemValue = JSON.stringify({
      linkType: val("linkType"),
      title: val("title"),
      url: val("url"),
    });
  } else if (value.itemTypeCode === "weblink") {
    value.itemValue = JSON.stringify({ title: val("title"), url: val("url") });
  }
  return value;
}
